import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import HelpText from '../../../../../components/HelpText/index';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import { Validate } from '../../../../../components/Validation';
import { required } from '../../../../../utils/validation/validator';
import CurrencySelector from '../../../components/CurrencySelector';

export class AdditionalExpensesListItem extends React.Component {
  onDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove && this.props.total > 1) {
      this.props.onRemove(this.props.item.id);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };


  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto mb02">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto mb02">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.additionalExpenseTitle}
                values={{ index: this.props.index + 1 }}
              />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-3 col-sm-5 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.dateOfExpense}
              fieldName={messages.additionalExpensesDateOfExpense}
            >
              <DatePicker
                disabled={disabled}
                type="text"
                onDayChange={this.onDayChange('dateOfExpense')}
                value={item.dateOfExpense}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.additionalExpensesDateOfExpense}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-7 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.description}
              fieldName={messages.additionalExpensesDescription}
            >
              <Textbox
                disabled={disabled}
                type="text"
                onChange={this.onChange('description')}
                value={item.description}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.additionalExpensesDescription}
                />
              </ErrorMessage>
            </Validate>
            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Train to Paris' }}
              />
            </HelpText>
          </div>
          <div className="form-group col-md-4 col-sm-6 mb02">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.supplier}
              fieldName={messages.additionalExpensesSupplier}
            >
              <Textbox
                disabled={disabled}
                type="text"
                onChange={this.onChange('supplier')}
                value={item.supplier}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.additionalExpensesSupplier}
                />
              </ErrorMessage>
            </Validate>
            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Eurostar' }}
              />
            </HelpText>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-6 col-sm-6">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.amountPaid}
                fieldName={messages.additionalExpensesAmountPaid}
              >
                <Textbox
                  disabled={disabled}
                  type="number"
                  onChange={this.onChange('amountPaid')}
                  value={item.amountPaid}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.additionalExpensesAmountPaid}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountPaidCurrency}
              fieldName={messages.additionalExpensesCurrency}
            >

              <CurrencySelector
                onChange={this.handleCurrencyChange('amountPaidCurrency')}
                disabled={disabled}
                value={item.amountPaidCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.additionalExpensesCurrency}
                />
              </ErrorMessage>
            </Validate>
            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Euro' }}
              />
            </HelpText>
          </div>
        </div>
      </div>
    );
  }
}

AdditionalExpensesListItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  total: PropTypes.number,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  removable: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/components/AdditionalExpenses/AdditionalExpensesListItem.js